import type { ComponentProps, ReactNode } from "react";
import type { MotionValue } from "framer-motion";

/**
 * All available SolidShape variants. The source of truth for randomised
 * marker pickers (e.g. `Overline`'s icon) — keep in sync with the type
 * below.
 */
export const SOLID_SHAPE_VARIANTS = [
  "diamond",
  "concave-square",
  "pinwheel",
  "starburst",
  "sunburst",
  "quadrant",
  "arch",
  "circle",
  "square-1-round-corner",
  "square-2-round-corner",
  "squircle",
  "rounded-square",
  "rounded-rectangle-stack",
  "round-rectangle-stack",
  "hourglass-block",
] as const;

export type SolidShapeVariant = (typeof SOLID_SHAPE_VARIANTS)[number];

export type SolidShapeColor =
  | "bright-blue"
  | "light-green"
  | "turquoise"
  | "peach"
  | "avocado"
  | "sky-blue"
  | "orange"
  | "sea"
  | "mint"
  | "yellow"
  | "cobalt"
  | "ocean"
  | "afternoon"
  | "white";

export interface SolidShapeProps extends ComponentProps<"div"> {
  variant: SolidShapeVariant;
  color: SolidShapeColor;
  animated?: boolean;
  children?: ReactNode;
}

export interface SolidShapeVariantProps extends ComponentProps<"div"> {
  color?: SolidShapeColor;
  animated?: boolean;
  children?: ReactNode;
}

export interface SolidShapeSvgProps {
  color: SolidShapeColor;
  animated: boolean;
  shapeScale: MotionValue<number>;
}
